var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_vm._l((_vm.$store.state.carts),function(cart){return [_c('v-card',{key:cart.id,staticClass:"mb-3"},[_c('review-headline',{attrs:{"cart":cart}}),_c('review-products',{attrs:{"cart":cart}})],1)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }